import styled from "styled-components";
import { H1 } from "../../../common";

export const BlogTitle = styled(H1)`
  padding: 40px 0 0 5px;
  margin-bottom: 30px;

  line-height: ${({ theme }) => theme.lineHeight.xl};
`;
